












































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue';

import CanvasEditor from '@/modules/photoEditor/CanvasEditor.vue';
import { DxColorBox, DxSlider, DxSwitch } from 'devextreme-vue';

@Component({
  components: {
    DxPopup,
    DxToolbarItem,
    DxScrollView,
    CanvasEditor,
    DxColorBox,
    DxSlider,
    DxSwitch,
  },
})
export default class ImageUploadPopup extends Vue {

    @Prop({required: true, default: false})
    public show?: boolean;

    @Prop({required: false, default: false})
    public saving?: boolean;

    private fullScreen: boolean = false;
    private color: string = '#f05b41';
    private size: number = 5;
    private erase: boolean = false;

    private hide() {
        this.$emit('hide');
    }

    private save() {
        const blob = (this.$refs.canvasEditor as CanvasEditor).getDataAsBlob();
        const date = new Date();
        const filename = `${date.getFullYear()}-${date.getMonth()}-${date.getDay()}-${date.getHours()}-${date.getMinutes()}-${date.getSeconds()}.png`;
        this.$emit('save', {blob, filename});
    }

    private imageChanged(e: any) {
        const files = e.target.files;

        // const logoImg = new Image();
        // logoImg.src = window.URL.createObjectURL(files[0]);

        (this.$refs.canvasEditor as CanvasEditor).setImage(window.URL.createObjectURL(files[0]));
    }

    private toggleFullScreen() {
        this.fullScreen = !this.fullScreen;
    }

    get sliderTooltip() {
        return { enabled: true, showMode: 'onHover', position: 'bottom', format: (value: string) => value };
    }
}
